"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IPaperWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _Toolbar = require("../../components/Toolbar");
var _variables = require("../../constants/variables");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/naming-convention -- iPaper is the name of the flipbook */ // TODO -- Replace with sm when Checkout adjust the mobile breakpoint on MiniShoppingBag
const CHECKOUT_MOBILE_BREAKPOINT = 1024;
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        background: theme.palette.common.white,
        display: 'grid',
        gridTemplateRows: "".concat(_variables.TOOLBAR_HEIGHT, " 1fr"),
        height: 'calc(100dvh - var(--top-nav-height, 94px))',
        maxWidth: '100%',
        position: 'fixed',
        top: 'var(--top-nav-height, 94px)',
        width: '100vw',
        zIndex: 1,
        [theme.breakpoints.up(CHECKOUT_MOBILE_BREAKPOINT)]: {
            height: 'calc(100dvh - var(--top-nav-height, 98px))',
            top: 'var(--top-nav-height, 98px)',
            width: "calc(100vw - var(--minibag-desktop-width, ".concat(_variables.DEFAULT_MINIBAG_WIDTH, "))")
        }
    };
});
const IPaperWrapper = exports.IPaperWrapper = /*#__PURE__*/ (0, _react.memo)((param)=>{
    let { children } = param;
    const { width } = (0, _presentationHooks.useWindowSize)({
        delay: 500
    });
    (0, _react.useEffect)(()=>{
        (0, _utils.setCssVariables)();
    }, [
        children,
        width
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        id: _utils.IPAPER_ROOT_ID,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Toolbar.Toolbar, {}),
            children
        ]
    });
});
